import * as React from 'react'

import './PageNotFound.scss'

import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Body1, Heading1, Heading3 } from '@/components/ui/typography'

const PageNotFound: React.ComponentType = () => {
  const navigate = useNavigate()
  return (
    <div id='notfound'>
      <div className='not-found'>
        <div className='not-found__404'>
          <Heading3>Oops! Page not found</Heading3>
          <Heading1>
            <span>4</span>
            <span>0</span>
            <span>4</span>
          </Heading1>
        </div>

        <Body1>we are sorry, but the page you requested was not found</Body1>
        <Button onClick={() => navigate('/')}>Go back</Button>
      </div>
    </div>
  )
}
export default PageNotFound
